<template>
<div>
    <job-detail-form ref="jobDetailForm"></job-detail-form>
    <!-- modal -->
    <b-modal id="trademarkObjectionToUsFormModal" centered size="xl" no-close-on-backdrop ref="trademarkObjectionToUsFormModal" :title=" $t('trademarkObjectionToUs.info')"  hide-footer>
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-md-3">
                    <b-form-group :disabled="true">
                        <label for="trademark-objection-to-us-date">{{ $t('trademarkObjectionToUs.date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="date"  ></CustomDatePicker>
                    </b-form-group>
                </b-col>
                 <b-col class="col-md-3">
                    <label for="trademark-objection-to-us-owner-input">{{ $t('trademarkObjectionToUs.owner') }}</label>
                    <b-form-input :disabled="true" size="sm" id="trademark-objection-to-us-owner-input" v-model="owner" :placeholder="$t('trademarkObjectionToUs.owner')" maxlength="200"  />
                </b-col>
                 <b-col class="col-md-6">
                    <label for="trademark-objection-to-us-ground-of-objection-input">{{ $t('trademarkObjectionToUs.ground_of_objection') }}</label>
                    <b-form-input :disabled="true" size="sm" id="trademark-objection-to-us-ground-of-objection-input" v-model="groundOfObjection" :placeholder="$t('trademarkObjectionToUs.ground_of_objection')" maxlength="200"  />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getTrademarkObjectionToUsList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            trademarkId: 0,
            jobId: 0,
            owner: '',
            groundOfObjection: '',
            date: null,
        }
    },
    methods: {
        showInfo(id, trademarkId) {
            this.id = id
            this.trademarkId = trademarkId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'TrademarkObjectionToUs'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.owner = response.data.trademarkObjectionToUs.owner
                    this.groundOfObjection = response.data.trademarkObjectionToUs.groundOfObjection
                    this.date = response.data.trademarkObjectionToUs.date
                    this.jobId = response.data.trademarkObjectionToUs.jobId;
                    if(this.jobId > 0){
                        this.$refs.jobDetailForm.getJobDetailList(this.jobId);
                    }else{
                         this.$refs['trademarkObjectionToUsFormModal'].show()
                    }      
                } else {
                    this.$bvModal.hide('trademarkObjectionToUsFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }  
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    height: 2.7em;
}

[dir] .btn-secondary {
    border: 1px solid #7367f0 !important;
    background-color: transparent !important;
}
.datepickerStyle{
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
